export default {
  sm: `
    데이터센터를 위한 자연환경,
    춘천시 구봉산 자락  
  `,
  md: `
    데이터센터를 위한
    자연환경,
    춘천시 구봉산 자락  
  `,
  lg: `
    데이터센터를 위한 자연환경,
    춘천시 구봉산 자락  
  `,
};
